// src/index.ts
import pino2 from "pino";

// src/create-logger.ts
import pino from "pino";
var sentryHook;
function setSentryBreadcrumbHook(hook) {
  sentryHook = hook;
}
var LOG_LEVELS = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40
};
function resolveArgs(contextOrMessage, maybeMessage) {
  if (typeof contextOrMessage === "string") {
    return { context: {}, message: contextOrMessage };
  }
  return { context: contextOrMessage, message: maybeMessage ?? "" };
}
function wrapPinoLogger(pinoLogger) {
  function createLogFn(level2) {
    return (contextOrMessage, maybeMessage) => {
      const { context, message } = resolveArgs(contextOrMessage, maybeMessage);
      const hasContext = Object.keys(context).length > 0;
      if (hasContext) {
        pinoLogger[level2](context, message);
      } else {
        pinoLogger[level2](message);
      }
      if (sentryHook && LOG_LEVELS[level2] >= LOG_LEVELS.info) {
        sentryHook(level2, message, hasContext ? context : void 0);
      }
    };
  }
  return {
    debug: createLogFn("debug"),
    info: createLogFn("info"),
    warn: createLogFn("warn"),
    error: createLogFn("error"),
    child: (bindings) => wrapPinoLogger(pinoLogger.child(bindings))
  };
}
function createLogger(options = {}) {
  const isDev = false;
  const level2 = options.level ?? (isDev ? "debug" : "info");
  const transport2 = isDev ? { target: "pino-pretty" } : void 0;
  const bindings = {};
  if (options.service) {
    bindings.service = options.service;
  }
  const pinoLogger = pino({
    level: level2,
    transport: transport2,
    ...Object.keys(bindings).length > 0 ? { base: bindings } : {}
  });
  return wrapPinoLogger(pinoLogger);
}

// src/index.ts
var level = false ? "debug" : "info";
var transport = false ? { target: "pino-pretty" } : void 0;
function getTraceId(headers) {
  if (headers instanceof Headers) {
    return headers.get("x-trace-id") || headers.get("x-request-id") || crypto.randomUUID();
  }
  return headers["x-trace-id"] || headers["x-request-id"] || crypto.randomUUID();
}
function genReqId(req) {
  return getTraceId(req.headers);
}
var logger = pino2({
  level,
  transport
});
var pinoHttpConfig = {
  level,
  transport,
  genReqId,
  autoLogging: {
    ignore: (req) => true
  }
};
var getLoggerConfig = (environment, logLevel) => {
  return {
    pinoHttp: {
      ...pinoHttpConfig,
      level: logLevel || environment === "development" ? "debug" : "info",
      transport: environment === "development" ? { target: "pino-pretty" } : void 0
    }
  };
};
export {
  createLogger,
  getLoggerConfig,
  getTraceId,
  logger,
  pinoHttpConfig,
  setSentryBreadcrumbHook
};
//# sourceMappingURL=index.js.map